import {combineReducers} from 'redux';
import sidebar from './Sidebar';
import profile from './Profile';


export default combineReducers({
    sidebar,
    profile
})